import { Component, inject, Input } from '@angular/core';
import { SessionVariable } from '../../../../common/enum/session-variable';
import { LocalStorageService } from '../../../../common/services/local-storage.service';

@Component({
  selector: 'taly-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss'],
  standalone: false,
})
export class PaymentMethodComponent {
  private storageService = inject(LocalStorageService);

  @Input() type!: string;
  paymentPlanId: string | null = this.storageService.getItem(SessionVariable.PAYMENT_PLAN_ID);
}
